import { editTeamFail, editTeamSuccess } from './actions';
import { put } from 'redux-saga/effects';
import { makeErrorPayload } from '../../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../../shared/toast/redux/actions';
import { fetchTeamDetailsSuccess } from '../team-details/actions';
import { updateTeam } from '../team.backend';

export function* editTeamSaga(action) {
    const { teamId, teamDetails } = action.payload;

    try {
        const response = yield updateTeam(teamId, teamDetails);
        yield put(editTeamSuccess(response.data));
        yield put(fetchTeamDetailsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(editTeamFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
